<form #formControl="ngForm" class="edit-dialog">
  <h2 mat-dialog-title>{{ getDialogTitle() }}</h2>

  <mat-dialog-content>
    <div class="form-container">
      <mat-form-field appearance="outline" color="accent" class="full-width">
        <mat-label>Binding Name</mat-label>
        <input matInput [(ngModel)]="bindingName" name="bindingName" placeholder="Enter binding name" required />
        <mat-hint>A unique name for this property binding</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Target Field</mat-label>
        <mat-select [(ngModel)]="targetField" (ngModelChange)="onTargetFieldSelection($event)" name="selectedTargetField" placeholder="Select target field" required>
          @for (item of getAvailableFields(); track item.id ?? item.name) {
          <mat-option [value]="item">
            {{ item.name }}
          </mat-option>
          }
        </mat-select>
        <mat-hint>The field to bind colors to</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Shape</mat-label>
        <mat-select [(ngModel)]="selectedShape" name="selectedShape" placeholder="Select shape" required>
          @for (item of shapeList; track item) {
          <mat-option [value]="item">
            {{ item }}
          </mat-option>
          }
        </mat-select>
        <mat-hint>Visual shape for the binding</mat-hint>
      </mat-form-field>

      <div class="color-picker-section">
        <div class="color-picker-container">
          <label class="color-label">Default Color</label>
          <input [(colorPicker)]="defaultColor" [style.background]="defaultColor" name="defaultColor" class="color-input" (colorPickerChange)="onDefaultColorChange($event)" />
          <span class="color-value">{{ defaultColor }}</span>
        </div>
      </div>

      @if (targetField?.fieldType === 'DropdownSingle') {
      <div class="color-options-container">
        <h4 class="section-title">
          <mat-icon class="section-icon">palette</mat-icon>
          Dropdown Color Options
        </h4>
        @for (val of targetField.value?.options; track val; let i = $index) {
        <div class="color-option-row">
          <input [(colorPicker)]="colorData[i].color" [style.background]="colorData[i].color" name="nodecolor_{{ i }}" class="color-input" (colorPickerChange)="onColorDataChange(i, $event)" />
          <span class="option-label">{{ val }}</span>
          <span class="option-color-value">{{ colorData[i]?.color }}</span>
        </div>
        }
      </div>
      } @if (targetField?.fieldType === 'Checkbox') {
      <div class="color-options-container">
        <h4 class="section-title">
          <mat-icon class="section-icon">check_box</mat-icon>
          Checkbox Colors
        </h4>
        @if (colorData.length >= 2) {
        <div class="color-option-row">
          <input [(colorPicker)]="colorData[0].color" [style.background]="colorData[0].color" name="nodecolor_checked" class="color-input" (colorPickerChange)="onColorDataChange(0, $event)" />
          <span class="option-label">{{ colorData[0].value }}</span>
          <span class="option-color-value">{{ colorData[0].color }}</span>
        </div>
        <div class="color-option-row">
          <input [(colorPicker)]="colorData[1].color" [style.background]="colorData[1].color" name="nodecolor_unchecked" class="color-input" (colorPickerChange)="onColorDataChange(1, $event)" />
          <span class="option-label">{{ colorData[1].value }}</span>
          <span class="option-color-value">{{ colorData[1].color }}</span>
        </div>
        }
      </div>
      } @if (hasChanges()) {
      <div class="changes-indicator">
        <mat-icon class="changes-icon">info</mat-icon>
        <span>You have unsaved changes</span>
      </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="resetForm()" [disabled]="!hasChanges()" type="button">Reset</button>
    <button mat-button (click)="onNoClick()" type="button" tabindex="-1">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!formControl.valid || !isFormValid()" (click)="confirmAdd()" type="button">Save Changes</button>
  </mat-dialog-actions>
</form>
